import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function BenefitsTable() {
  const benefits = [{
    feature: 'Espejo interactivo de lujo con iluminación LED',
    meaning: 'Tu evento se ve elegante, moderno y listo para Instagram desde el primer segundo'
  }, {
    feature: 'Fotos impresas al instante',
    meaning: 'Cada invitado se va con un recuerdo físico esa misma noche — no mañana, no en tres semanas'
  }, {
    feature: 'Personalización con el nombre y fecha de tu evento',
    meaning: 'Cada foto es única para TU celebración. No genérica. Tuya'
  }, {
    feature: 'Experiencia 100% interactiva y divertida',
    meaning: 'Tus invitados de todas las edades participan — desde los niños hasta la abuelita'
  }, {
    feature: 'Diseño Instagramable',
    meaning: 'El espejo ES decoración. Hace tu evento más bonito y más compartible'
  }, {
    feature: 'Atención personalizada en español',
    meaning: 'Trabajamos contigo antes, durante y después del evento. En tu idioma, con tu cultura'
  }, {
    feature: 'Impresión profesional de alta calidad',
    meaning: 'No son selfies borrosas. Son fotos que se ven hermosas en cualquier pared'
  }];
  return <section className="py-20 md:py-28 bg-ink relative" data-id="element-1" data-mp="2md0puod3omze">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl" data-id="element-2" data-mp="28e9c5325h3bs">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-3" data-mp="28h5bmvtnc02c">
          <div className="text-center mb-16" data-id="element-4" data-mp="3trvmygtcpx4o">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-cream mb-4" data-id="element-5" data-mp="3tq1212i2y50l">
              Lo que obtienes y lo que significa
            </h2>
            <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-6" data-mp="1aljh3qlypwpt"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-7" data-mp="15loq7n26t74r">
            {benefits.map((item, index) => <div key={index} className="bg-charcoal rounded-2xl p-6 border border-gold/10 hover:border-gold/30 transition-colors shadow-lg" data-id="element-8" data-mp="11lmnrbomo9of" data-mpi={index}>
                <div className="flex items-start gap-4 mb-4" data-id="element-9" data-mp="1tc0v0p24ynr4">
                  <div className="bg-gold/10 p-2 rounded-full shrink-0 mt-1" data-id="element-10" data-mp="1tdlpyfsd48pi">
                    <Check className="w-5 h-5 text-gold" data-id="element-11" data-mp="1paz4cwmabk0r" />
                  </div>
                  <h3 className="text-lg font-medium text-cream" data-id="element-12" data-mp="1ki5z87mwm9o5">
                    {item.feature}
                  </h3>
                </div>
                <div className="pl-13 border-t border-white/5 pt-4 mt-2" data-id="element-13" data-mp="2czrv8eo1v1oi">
                  <p className="text-cream/70 font-light text-sm md:text-base" data-id="element-14" data-mp="2d1uttn39q34u">
                    <span className="text-gold/80 font-medium mr-2" data-id="element-15" data-mp="287gvpcx81hwh">
                      Lo que significa:
                    </span>
                    {item.meaning}
                  </p>
                </div>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}